import { FaTimes, FaSave } from "react-icons/fa";
import { PrimaryButton, SecondaryButton } from "../../../UI/DesignStandards";

const PrizeFundDistributionActions = ({
  editMode,
  canManage,
  isPayoutFinalized,
  isSubmitting,
  onCancel,
  onSave,
}) => {
  if (!editMode || !canManage) return null;

  return (
    <div className="flex justify-end space-x-3 pt-4">
      <SecondaryButton
        onClick={onCancel}
        disabled={isPayoutFinalized || isSubmitting}
        title={
          isPayoutFinalized
            ? "Payouts have been locked and cannot be changed"
            : isSubmitting
            ? "Please wait while changes are being saved"
            : "Cancel editing"
        }
      >
        <FaTimes className="mr-2" />
        Cancel
      </SecondaryButton>
      <PrimaryButton
        onClick={onSave}
        disabled={isPayoutFinalized || isSubmitting}
        title={
          isPayoutFinalized
            ? "Payouts have been locked and cannot be changed"
            : isSubmitting
            ? "Please wait while changes are being saved"
            : "Save distribution changes"
        }
      >
        <FaSave className="mr-2" />
        Save Distribution
      </PrimaryButton>
    </div>
  );
};

export default PrizeFundDistributionActions;
